import { render, staticRenderFns } from "./UserPasswordModal.vue?vue&type=template&id=ff06ccb8&scoped=true&"
import script from "./UserPasswordModal.vue?vue&type=script&lang=js&"
export * from "./UserPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./UserPasswordModal.vue?vue&type=style&index=0&id=ff06ccb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff06ccb8",
  null
  
)

export default component.exports